import {SagaIterator} from 'redux-saga';
import {all, call, putResolve, select} from 'redux-saga/effects';

import {SEGMENT_FOR_MENTION_ME} from 'constants/analytics/mentionMe';

import {getQuote} from 'desktop/pages/cart/store/reducers/quoteItems/quoteItems';
import {getAffId} from 'libs/analytics/affiliate';
import {apiConfig} from 'libs/api/api';
import {isUhcEnabled} from 'libs/rollout';
import {localStore} from 'libs/storage/storage';

import {completeOrderReview} from '../../actions/completeOrder/completeOrder';
import {
    getAmazonV2,
    getNameSelectedMethod,
    getPayerInfo,
} from '../../selectors/paymentStep/paymentStep';

/**
 * Saga for saveOrder request
 */
export function* onPlaceOrderSaga(): SagaIterator {
    const hostState = apiConfig.hostStore.getState();
    const {search} = hostState.router.location;
    const {form_key: formKey} = hostState.customer;
    const [payerInfo, namePaymentMethod, affid, {accessToken}] = yield all([
        select(getPayerInfo),
        select(getNameSelectedMethod),
        call(getAffId, {search}),
        select(getAmazonV2),
    ]);

    const data = {
        ...{
            ...payerInfo.options,
            subscribe: isUhcEnabled() ? false : payerInfo.options.subscribe,
        },
        ...payerInfo.info,
        accessToken,
        affid,
        method: namePaymentMethod,
    };

    if (!isUhcEnabled()) {
        data.subscribe = false;
    }

    yield putResolve(getQuote({shouldSkipEEC: false}));

    const completeOrder = yield putResolve(completeOrderReview({formKey, paymentInfo: data}));
    yield call(
        [localStore, 'set'],
        SEGMENT_FOR_MENTION_ME,
        completeOrder?.payload?.data?.mention_me_segment || '',
    );
}
